package org.teddapp.project.ui

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.input.OffsetMapping
import androidx.compose.ui.text.input.TransformedText
import androidx.compose.ui.text.input.VisualTransformation

/**
 * Montre un nombre tapé en chiffres avec ses milliers séparés par une espace insécable :
 * « 1250000 » s'affiche « 1 250 000 ». La valeur du champ reste les chiffres nus ; seul
 * l'affichage change, et le curseur suit les espaces ajoutées.
 */
object TeddThousandsTransformation : VisualTransformation {
    override fun filter(text: AnnotatedString): TransformedText {
        val digits = text.text
        if (digits.length <= 3 || digits.any { !it.isDigit() }) return TransformedText(text, OffsetMapping.Identity)
        val shown = formatThousands(digits.toLongOrNull() ?: return TransformedText(text, OffsetMapping.Identity))
        // Espaces avant la position i : une par groupe de trois chiffres complet à sa gauche.
        val head = digits.length % 3
        fun spacesBefore(i: Int): Int = if (i <= head) 0 else (i - head + 2) / 3 - (if (head == 0) 1 else 0)
        val mapping = object : OffsetMapping {
            override fun originalToTransformed(offset: Int): Int = offset + spacesBefore(offset.coerceIn(0, digits.length))
            override fun transformedToOriginal(offset: Int): Int {
                val o = offset.coerceIn(0, shown.length)
                return o - shown.substring(0, o).count { !it.isDigit() }
            }
        }
        return TransformedText(AnnotatedString(shown), mapping)
    }
}
